module.exports = __webpack_public_path__ + "assets/portal-view.png?bc4f213b367e1e8fa8807fbe061cea5e";